'use client'

import styles from "./BuildNation.module.scss";
import cn from "clsx";
import Markdown from "@/components/atoms/Markdown";
import Button from "@/components/atoms/Button";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Link from "next/link";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import ShowImageOnViewPort from "@/helpers/ShowImageOnViewPort";
import {imgPathReplace} from '@/helpers/imgPathReplace';
import TestimonialsCarousel from  "@/components/sections/TestimonialStudent";

export default function BuildNation({
  item,
  isMobile,
  smallFont,
  hasFullWidth,
  isLandingPage,
  testimonials
}: {
  item: any;
  isMobile:boolean,
  smallFont?: boolean;
  hasFullWidth?: boolean;
  isLandingPage?: boolean;
  testimonials?: any;
}) {
  const img = strapiSingleAttribute(item?.Image?.source || item?.Image);

  const GAEventsHandler = () => {
      pushToDataLayer({
        'event': 'generic_cta_click',
        'cta_text': item?.CTA?.text,
        'section_name': item?.Heading?.text.replace(/_/g, ""),
        'page_type': getGlobalStateValue('pageType')
      });
  }

  return (
    <div className={cn("container", styles.root)}>
  <div className={cn("lg:flex justify-between",isLandingPage ? styles.lpWrapper : styles.wrapper)}>
        <div className={cn(styles.content,{[styles.lp]:!isLandingPage})}>
          <div className="flex flex-col w-full">
            <div className="flex items-start justify-between w-full">
              {item?.Heading?.enabled && (
                <Markdown
                  as="h2"
                  id = "overview-old-heading"
                  className={cn(styles.heading, {
                    [styles.smallFont]: smallFont,
                    ["!w-full"]: hasFullWidth,
                  })}
                >
                  {item?.Heading?.text?.replace(/\n/gi, "  \n")} 
                </Markdown>
              )}

              {item?.Icon?.enabled && (
                <img
                  src={imgPathReplace(item.Icon.source.data?.[0]?.attributes?.url)}
                  alt={item.Icon.source.data?.[0]?.attributes?.alternativeText || 'Amity Online'}
                  className="w-[51px] h-[51px] xl:w-[82px] xl:h-[81.95px]"
                  loading="lazy"
                  title="Amity Online"
                />
              )}
            </div>
            {item?.Description?.enabled && <>
              {item?.Description?.customText ? (
                <div 
                  className={cn(styles.desc, {
                    ["!w-full"]: hasFullWidth,
                  })}
                  dangerouslySetInnerHTML={{
                    __html: item?.Description?.customText
                  }}
                />
              ) : (
                <Markdown 
                  as="p"
                  className={cn(styles.desc, {
                    ["!w-full"]: hasFullWidth,
                  })}
                >
                  {item?.Description?.text || item?.Description?.ckrich}
                </Markdown>
              )}
              {item?.Description?.text2 &&  <Markdown as="p"
                className={cn(styles.desc, {
                  ["!w-full"]: hasFullWidth,
                })}
              >
                {item?.Description?.text2}
              </Markdown>}
            </>
              
            }
            {item?.CTA?.enabled && (
              <div className={styles.cta}>
                <Button
                  buttonProps={{
                    href: item?.CTA?.url,
                    target: item?.CTA?.target?.[0] || item?.CTA?.target,
                    onClick: GAEventsHandler
                  }}
                  className={styles.ctaBtn}
                  icon="/_a/icons/left-arrow.svg"
                  hoverIcon="/_a/icons/left-arrow-white.svg"
                  bg="o"
                >
                  {item?.CTA?.text}
                </Button>
              </div>
            )}
          </div>
        </div>
        {isLandingPage? ""
        :(((item?.MobileImage?.enabled) || (item?.Image?.enabled)) && (
        <div className={cn(styles.image_wrapper)}>
              {!!img?.url ? (
                <ShowImageOnViewPort
                  className={cn("object-cover rounded-2xl", styles.image)}
                  src={imgPathReplace(img?.url)}
                  alt={item?.Image?.alt || "amity online"}
                  title="Amity Online"
                  width={isMobile ? 600 : 388}
                  height={isMobile ? 320 : 178}
                />
              ) : null}
        </div>
           
      ))
     
      }
       
       
      </div>
    </div>
  );
}
